// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/incident.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { MetricConfig } from "../../artifacts/v1/chart_pb";
import { file_chalk_artifacts_v1_chart } from "../../artifacts/v1/chart_pb";
import type { DenseTimeSeriesChart } from "../../chart/v1/densetimeserieschart_pb";
import { file_chalk_chart_v1_densetimeserieschart } from "../../chart/v1/densetimeserieschart_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/server/v1/incident.proto.
 */
export const file_chalk_server_v1_incident: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_artifacts_v1_chart, file_chalk_chart_v1_densetimeserieschart, file_google_protobuf_timestamp]);

/**
 * @generated from message chalk.server.v1.IncidentLinkedEntity
 */
export type IncidentLinkedEntity = Message<"chalk.server.v1.IncidentLinkedEntity"> & {
  /**
   * @generated from field: chalk.server.v1.IncidentEntityKind entity_kind = 1;
   */
  entityKind: IncidentEntityKind;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId: string;
};

/**
 * Describes the message chalk.server.v1.IncidentLinkedEntity.
 * Use `create(IncidentLinkedEntitySchema)` to create a new message.
 */
export const IncidentLinkedEntitySchema: GenMessage<IncidentLinkedEntity> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_incident, 0);

/**
 * @generated from message chalk.server.v1.IncidentGroup
 */
export type IncidentGroup = Message<"chalk.server.v1.IncidentGroup"> & {
  /**
   * @generated from field: string group_key = 1;
   */
  groupKey: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;
};

/**
 * Describes the message chalk.server.v1.IncidentGroup.
 * Use `create(IncidentGroupSchema)` to create a new message.
 */
export const IncidentGroupSchema: GenMessage<IncidentGroup> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_incident, 1);

/**
 * IncidentSnapshot records static details of an incident as of when it opened, stored in the
 * Incident.snapshot column. Unlike entity links, a snapshot is not queried across incidents.
 *
 * @generated from message chalk.server.v1.IncidentSnapshot
 */
export type IncidentSnapshot = Message<"chalk.server.v1.IncidentSnapshot"> & {
  /**
   * @generated from oneof chalk.server.v1.IncidentSnapshot.body
   */
  body: {
    /**
     * @generated from field: chalk.server.v1.MetricMonitorSnapshot metric_monitor = 1;
     */
    value: MetricMonitorSnapshot;
    case: "metricMonitor";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.server.v1.IncidentSnapshot.
 * Use `create(IncidentSnapshotSchema)` to create a new message.
 */
export const IncidentSnapshotSchema: GenMessage<IncidentSnapshot> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_incident, 2);

/**
 * @generated from message chalk.server.v1.MetricMonitorSnapshot
 */
export type MetricMonitorSnapshot = Message<"chalk.server.v1.MetricMonitorSnapshot"> & {
  /**
   * The triggering series' groups, keyed and valued as displayed.
   *
   * @generated from field: repeated chalk.server.v1.IncidentGroup groups = 1;
   */
  groups: IncidentGroup[];
};

/**
 * Describes the message chalk.server.v1.MetricMonitorSnapshot.
 * Use `create(MetricMonitorSnapshotSchema)` to create a new message.
 */
export const MetricMonitorSnapshotSchema: GenMessage<MetricMonitorSnapshot> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_incident, 3);

/**
 * @generated from message chalk.server.v1.MetricIncident
 */
export type MetricIncident = Message<"chalk.server.v1.MetricIncident"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: google.protobuf.Timestamp started_at = 2;
   */
  startedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp closed_at = 3;
   */
  closedAt?: Timestamp;

  /**
   * @generated from field: chalk.artifacts.v1.MetricConfig metric_config = 4;
   */
  metricConfig?: MetricConfig;

  /**
   * @generated from field: optional chalk.server.v1.IncidentLinkedEntity linked_entity = 5 [deprecated = true];
   * @deprecated
   */
  linkedEntity?: IncidentLinkedEntity;

  /**
   * ID used to deduplicate alerts when sent to pagerduty, datadog, etc.
   *
   * @generated from field: string dedupe_key = 6;
   */
  dedupeKey: string;

  /**
   * @generated from field: repeated chalk.server.v1.IncidentGroup groups = 7;
   */
  groups: IncidentGroup[];

  /**
   * 'Group By' clauses could lead to multiple linked entities
   *
   * @generated from field: repeated chalk.server.v1.IncidentLinkedEntity linked_entities = 8;
   */
  linkedEntities: IncidentLinkedEntity[];
};

/**
 * Describes the message chalk.server.v1.MetricIncident.
 * Use `create(MetricIncidentSchema)` to create a new message.
 */
export const MetricIncidentSchema: GenMessage<MetricIncident> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_incident, 4);

/**
 * @generated from message chalk.server.v1.GetIncidentRequest
 */
export type GetIncidentRequest = Message<"chalk.server.v1.GetIncidentRequest"> & {
  /**
   * @generated from field: string incident_id = 1;
   */
  incidentId: string;
};

/**
 * Describes the message chalk.server.v1.GetIncidentRequest.
 * Use `create(GetIncidentRequestSchema)` to create a new message.
 */
export const GetIncidentRequestSchema: GenMessage<GetIncidentRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_incident, 5);

/**
 * @generated from message chalk.server.v1.GetIncidentResponse
 */
export type GetIncidentResponse = Message<"chalk.server.v1.GetIncidentResponse"> & {
  /**
   * @generated from field: chalk.server.v1.MetricIncident incident = 1;
   */
  incident?: MetricIncident;
};

/**
 * Describes the message chalk.server.v1.GetIncidentResponse.
 * Use `create(GetIncidentResponseSchema)` to create a new message.
 */
export const GetIncidentResponseSchema: GenMessage<GetIncidentResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_incident, 6);

/**
 * @generated from message chalk.server.v1.GetIncidentAlertsChartRequest
 */
export type GetIncidentAlertsChartRequest = Message<"chalk.server.v1.GetIncidentAlertsChartRequest"> & {
  /**
   * @generated from field: string incident_id = 1;
   */
  incidentId: string;

  /**
   * @generated from field: optional int64 point_limit = 2;
   */
  pointLimit?: bigint;
};

/**
 * Describes the message chalk.server.v1.GetIncidentAlertsChartRequest.
 * Use `create(GetIncidentAlertsChartRequestSchema)` to create a new message.
 */
export const GetIncidentAlertsChartRequestSchema: GenMessage<GetIncidentAlertsChartRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_incident, 7);

/**
 * @generated from message chalk.server.v1.GetIncidentAlertsChartResponse
 */
export type GetIncidentAlertsChartResponse = Message<"chalk.server.v1.GetIncidentAlertsChartResponse"> & {
  /**
   * @generated from field: chalk.chart.v1.DenseTimeSeriesChart chart = 1;
   */
  chart?: DenseTimeSeriesChart;
};

/**
 * Describes the message chalk.server.v1.GetIncidentAlertsChartResponse.
 * Use `create(GetIncidentAlertsChartResponseSchema)` to create a new message.
 */
export const GetIncidentAlertsChartResponseSchema: GenMessage<GetIncidentAlertsChartResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_incident, 8);

/**
 * @generated from message chalk.server.v1.ListIncidentsPageToken
 */
export type ListIncidentsPageToken = Message<"chalk.server.v1.ListIncidentsPageToken"> & {
  /**
   * Charts are sorted first by creation time, descending
   *
   * @generated from field: google.protobuf.Timestamp created_at_hwm = 1;
   */
  createdAtHwm?: Timestamp;

  /**
   * Then by id, descending.
   * Note: this is the chart link id, not the metric config id hwm!
   *
   * @generated from field: string id_hwm = 2;
   */
  idHwm: string;
};

/**
 * Describes the message chalk.server.v1.ListIncidentsPageToken.
 * Use `create(ListIncidentsPageTokenSchema)` to create a new message.
 */
export const ListIncidentsPageTokenSchema: GenMessage<ListIncidentsPageToken> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_incident, 9);

/**
 * @generated from message chalk.server.v1.ListIncidentsFilters
 */
export type ListIncidentsFilters = Message<"chalk.server.v1.ListIncidentsFilters"> & {
  /**
   * @generated from field: optional google.protobuf.Timestamp created_at_lower_bound_inclusive = 1;
   */
  createdAtLowerBoundInclusive?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_at_upper_bound_exclusive = 2;
   */
  createdAtUpperBoundExclusive?: Timestamp;

  /**
   * @generated from field: optional bool has_closed_filter = 3;
   */
  hasClosedFilter?: boolean;

  /**
   * @generated from field: optional chalk.server.v1.IncidentEntityKind linked_entity_kind_filter = 4;
   */
  linkedEntityKindFilter?: IncidentEntityKind;

  /**
   * @generated from field: optional string linked_entity_id_filter = 5;
   */
  linkedEntityIdFilter?: string;
};

/**
 * Describes the message chalk.server.v1.ListIncidentsFilters.
 * Use `create(ListIncidentsFiltersSchema)` to create a new message.
 */
export const ListIncidentsFiltersSchema: GenMessage<ListIncidentsFilters> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_incident, 10);

/**
 * @generated from message chalk.server.v1.ListIncidentsRequest
 */
export type ListIncidentsRequest = Message<"chalk.server.v1.ListIncidentsRequest"> & {
  /**
   * @generated from field: optional chalk.server.v1.ListIncidentsFilters filters = 1;
   */
  filters?: ListIncidentsFilters;

  /**
   * a default will be set if none is provided
   *
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;

  /**
   * Must be encoded ListIncidentsPageToken
   * see https://protobuf.dev/best-practices/api/#define-pagination-api
   *
   * @generated from field: optional string page_token = 3;
   */
  pageToken?: string;
};

/**
 * Describes the message chalk.server.v1.ListIncidentsRequest.
 * Use `create(ListIncidentsRequestSchema)` to create a new message.
 */
export const ListIncidentsRequestSchema: GenMessage<ListIncidentsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_incident, 11);

/**
 * @generated from message chalk.server.v1.ListIncidentsResponse
 */
export type ListIncidentsResponse = Message<"chalk.server.v1.ListIncidentsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.MetricIncident incidents = 1;
   */
  incidents: MetricIncident[];

  /**
   * must be encoded ListIncidentsPageToken
   *
   * @generated from field: optional string next_page_token = 2;
   */
  nextPageToken?: string;
};

/**
 * Describes the message chalk.server.v1.ListIncidentsResponse.
 * Use `create(ListIncidentsResponseSchema)` to create a new message.
 */
export const ListIncidentsResponseSchema: GenMessage<ListIncidentsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_incident, 12);

/**
 * @generated from enum chalk.server.v1.IncidentEntityKind
 */
export enum IncidentEntityKind {
  /**
   * @generated from enum value: INCIDENT_ENTITY_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INCIDENT_ENTITY_KIND_FEATURE = 1;
   */
  FEATURE = 1,

  /**
   * @generated from enum value: INCIDENT_ENTITY_KIND_RESOLVER = 2;
   */
  RESOLVER = 2,

  /**
   * @generated from enum value: INCIDENT_ENTITY_KIND_SCHEDULED_QUERY = 3;
   */
  SCHEDULED_QUERY = 3,

  /**
   * @generated from enum value: INCIDENT_ENTITY_KIND_QUERY = 4;
   */
  QUERY = 4,

  /**
   * @generated from enum value: INCIDENT_ENTITY_KIND_SQL_QUERY = 5;
   */
  SQL_QUERY = 5,

  /**
   * @generated from enum value: INCIDENT_ENTITY_KIND_DEPLOYMENT = 6;
   */
  DEPLOYMENT = 6,

  /**
   * @generated from enum value: INCIDENT_ENTITY_KIND_POD = 7;
   */
  POD = 7,

  /**
   * @generated from enum value: INCIDENT_ENTITY_KIND_SERVICE_KIND = 8;
   */
  SERVICE_KIND = 8,

  /**
   * @generated from enum value: INCIDENT_ENTITY_KIND_RESOURCE_GROUP = 9;
   */
  RESOURCE_GROUP = 9,

  /**
   * @generated from enum value: INCIDENT_ENTITY_KIND_OFFLINE_QUERY = 10;
   */
  OFFLINE_QUERY = 10,

  /**
   * @generated from enum value: INCIDENT_ENTITY_KIND_SCHEDULED_QUERY_RUN = 11;
   */
  SCHEDULED_QUERY_RUN = 11,

  /**
   * @generated from enum value: INCIDENT_ENTITY_KIND_TRAINING_RUN = 12;
   */
  TRAINING_RUN = 12,

  /**
   * @generated from enum value: INCIDENT_ENTITY_KIND_SCALING_GROUP = 13;
   */
  SCALING_GROUP = 13,

  /**
   * @generated from enum value: INCIDENT_ENTITY_KIND_NODE = 14;
   */
  NODE = 14,

  /**
   * @generated from enum value: INCIDENT_ENTITY_KIND_FUNCTION = 15;
   */
  FUNCTION = 15,

  /**
   * @generated from enum value: INCIDENT_ENTITY_KIND_SCALING_GROUP_REVISION = 16;
   */
  SCALING_GROUP_REVISION = 16,
}

/**
 * Describes the enum chalk.server.v1.IncidentEntityKind.
 */
export const IncidentEntityKindSchema: GenEnum<IncidentEntityKind> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_incident, 0);

